// extracted by mini-css-extract-plugin
module.exports = {"section":"Resetpin_section__ItWWa"};